import { INJ_DENOM_BASE, INJ_DENOM_PRECISION } from '@/constants/constants'
import { BigNumberInBase, BigNumberInWei } from '@injectivelabs/utils'

export const toBigNumberInWei = (amount: string, decimals = INJ_DENOM_BASE) =>
  new BigNumberInBase(amount).toWei(decimals)

type Options = {
  decimals: number
  precision: number
}

export const formatAmount = (amount: string, options?: Partial<Options>) => {
  const { decimals = INJ_DENOM_BASE, precision = INJ_DENOM_PRECISION } = options || {}
  return new BigNumberInWei(amount).toBase(decimals).toFixed(precision, BigNumberInWei.ROUND_DOWN)
}

export const formatAmount2 = (amount: string, options?: Partial<Options>) => {
  const { decimals = INJ_DENOM_BASE, precision = INJ_DENOM_PRECISION } = options || {}
  return new BigNumberInWei(amount).toBase(decimals).toFixed(precision, BigNumberInWei.ROUND_DOWN)
}

export const formatWalletAddress = (address: string): string => {
  if (address.length <= 10) {
    return address
  }

  return `${address.slice(0, 6)}...${address.slice(address.length - 6, address.length)}`
}
